
import $ from "jquery"
import _extend from "lodash/assign"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"


interface Selector {
  swiper_pagination:    string
}
interface InputSelector {
  swiper_pagination?:    string
}
const default_selector = {
  swiper_pagination: ".swiper-pagination",
}

class ListingSwiper {
  private selector: Selector
  private readonly $container_el: JQuery
  private readonly $swipe_pagination: JQuery

  private swiper: Swiper | undefined

  constructor({container_element, selector = {}}: {container_element: Element | string | JQuery, selector: InputSelector}) {
    if (container_element == null) {
      throw new Error("container_element is absent")
    }

    this.selector = _extend({}, default_selector, selector)
    this.$container_el = $(container_element)

    // region swiper instantiation

    this.$swipe_pagination = this.$container_el.find(this.selector.swiper_pagination)

    this.swiper = new Swiper(this.$container_el[0] as HTMLElement, {
      modules:    [Navigation, Pagination],
      pagination: {
        el:             this.$swipe_pagination[0] as HTMLElement,
        dynamicBullets: true,
      },
      speed:          500,
      direction:      "horizontal",
    })

    // endregion swiper instantiation

    this.bind_action()
  }

  protected bind_action(){
    this.$container_el.on("touchstart", () => {
      this.$container_el.attr("data-slideout-ignore", "true")
    })

    this.$container_el.on("touchend",() => {
      this.$container_el.attr("data-slideout-ignore", "false")
    })
  }
}

const Index = {
  create(container_element: Element | string | JQuery, selector?: InputSelector){
    return new ListingSwiper({container_element: container_element, selector: (selector || {})})
  },
}

export { Index as default }
